<template>
  <header class="flex">
    <div class="header-container box-shadow">
      <div class="docendo-logo box-shadow no-print">
        <span class="icon-docendo docendo-logo__icon" id="d-icon"></span>
      </div>
      <div class="nav">
        <div class="nav-left">
          <h2>{{calname}}</h2>
        </div>
        <div class="nav-right no-print">
          <set-locale
            @locale="emitLocale">
          </set-locale>
          <button @click="$emit('print')" class="print-button marg-5-left">
            <span class="icon-printer3"></span>
          </button>
          <!--
          <a href="https://docendo.dk/guide_til_print_elevvisning.pdf" target="_blank"
             class="bttn bttn-simple marg-5-left" v-if="locale === 'da'">
            {{ $t('calendars.public.printing_guide') }}
          </a>
          -->
        </div>
      </div>
    </div>
  </header>
</template>

<script>
  import setLocale from '../../Locale/SetLocale.vue'

  export default {
    components: {setLocale},
    props: ['calname', 'schoolname'],
    data () {
      return {
        locale: 'en'
      }
    },
    methods: {
      emitLocale (val) {
        this.locale = val
        this.$emit('locale', val)
      }
    },
    updated () {
      document.title = this.calname
    }
  }
</script>

<style scoped>
  header {
    flex-direction: column;
  }

  .header-container {
    display: flex;
    justify-content: space-between;
    background: white;
    position: relative;
    z-index: 130;
    width: 100%;
    max-width: 100%;
    height: 55px;
  }

  .nav {
    display: flex;
    justify-content: space-between;
    flex: 1;
    align-items: stretch;
  }

  .nav-left {
    padding: 0 20px;
    align-items: center;
    display: flex;
    vertical-align: middle;
  }

  .nav-right {
    margin-right: 20px;
    display: flex;
    vertical-align: middle;
    align-items: center;
  }

  .docendo-logo {
    float: left;
    box-sizing: border-box;
    width: 65px;
    height: 55px;
    background: #468ad7;
    color: #fff;
    cursor: pointer;
    position: relative;
    z-index: 10000;
    text-align: center;
  }

  .docendo-logo__icon {
    font-size: 45px;
    width: 100%;
    height: 100%;
    padding-top: 5px;
    display: block;
  }

  @media print {

    .header-container {
      height: 20px;
    }

    .header-container #docendo-logo {
      display: none;
    }

    .nav-left {
      padding: 0 0;
      position: fixed;
      right: 0;
      top: 0;
    }
  }

</style>



// WEBPACK FOOTER //
// Header.vue?c6961da6